export interface PromotionEvent {
    id: string;
    creative: string;
    creative_slot?: string;
    position: string;
}

export const PAGE_TYPE_MAP = {
    search: "Serp",
    hotel: "HotelPage",
    tourPage: "TourPage",
} as const;

export const LINK_BEHAVIOUR_MAP = {
    copy: 'Link_copy',
    openNewPage: 'Link_new_page',
    openThisPage: 'Link_this_page',
    close: 'Close_cross'
} as const;

export const BUTTON_BEHAVIOUR_MAP = {
    copy: 'Button_copy',
    close: 'Button_close',
    openNewPage: 'Button_new_page',
    openThisPage: 'Button_this_page'
} as const;

export class DataLayerService {
    static sendPromoView(promotion: Omit<PromotionEvent, 'position'>): void {
        // @ts-expect-error Нет типизации dataLayer для .ts-файлов
        window.dataLayer.push({
            "ecommerce": {
                "promoView": {
                    "promotions": [promotion]
                }
            }
        });
    }

    static sendPromoClick(promotion: PromotionEvent): void {
        // @ts-expect-error Нет типизации dataLayer для .ts-файлов
        window.dataLayer.push({
            "ecommerce": {
                "promoClick": {
                    "promotions": [promotion]
                }
            }
        });
    }
}